<template>
  <Link :href="href" target="_blank" :underline="true">{{ $t('yan-bi-fu-wu-xie-yi') }}</Link>
</template>

<script setup lang="ts">
import { getGlobalConfig } from '@rendora/common/utils/config';
import { Link } from '@rendora/design/components/link/index';
const isCN = getGlobalConfig().isCN;
const href = isCN
  ? 'https://frontend-protocol.xmov.ai/youyan-v3/credit-coin'
  : 'https://protocol.rendora.ai/legal/credit-coin';
</script>
